import { useState } from 'react'
import type { FC } from 'react'
import { FileModelJSON } from '~/models'

type Props = {
  files: FileModelJSON[]
  assetBaseURL: string
}

export const ProductImages: FC<Props> = ({
  assetBaseURL,
  files,
}) => {
  const [selectedFile, setSelectedFile] = useState<FileModelJSON | undefined>(files.at(0))

  return (
    <div className="px-2">
      <div className="h-72 w-full p-2 flex justify-center align-center my-auto self-middle">
        {selectedFile ? (
          <a
            className="h-full m-auto"
            target="_blank"
            rel="noopener noreferrer"
            href={`${assetBaseURL}/${selectedFile.path}`}
          >
            <img
              src={`${assetBaseURL}/${selectedFile.path}?w=600&h=600`}
              className="h-full w-auto object-contain"
            />
          </a>
        ) : (
          <img
            className="m-auto h-full"
            src="https://placehold.jp/300x300.png?text=noimage"
          />
        )}
      </div>
      <div className="w-full flex overflow-x-scroll self-end">
        {files.map(file =>
          <div key={file.path}
            className={
              (selectedFile && selectedFile.path === file.path ? 'border-2 border-secondary' : 'border')
              + ' w-24 h-24 flex-none flex justify-center align-center cursor-pointer shadow p-2 m-1 rounded'}
            onClick={() => setSelectedFile(file)}
          >
            <img
              className="m-auto h-full w-auto object-contain"
              key={file.path}
              src={`${assetBaseURL}/${file.path}?w=100&h=100`}
            />
          </div>
        )}
      </div>
    </div>
  )
}
